module.exports = __webpack_public_path__ + "static/media/PY.357ac133.svg";